/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { RouteResourceResponse } from '../../../../../common/types.tsx';
import type { ResourceStoreData } from '../../../../common/types.tsx';

export const transformData = (
	data: ResourceStoreData,
	transformer: (slice: RouteResourceResponse<unknown>) => RouteResourceResponse<unknown>,
): ResourceStoreData =>
	Object.keys(data).reduce((acc: ResourceStoreData, type: string) => {
		if (!acc[type]) {
			acc[type] = {};
		}

		Object.keys(data[type]).forEach((key) => {
			const slice = data[type][key];

			acc[type][key] = transformer(slice);
		});

		return acc;
	}, {});
